var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32.455 32.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25113",
    "data-name": "Path 25113",
    d: "M19.8,28.342A8.546,8.546,0,1,1,28.342,19.8,8.546,8.546,0,0,1,19.8,28.342Zm0-14.863A6.317,6.317,0,1,0,26.113,19.8,6.317,6.317,0,0,0,19.8,13.479Z",
    transform: "translate(4.863 4.863)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25114",
    "data-name": "Path 25114",
    d: "M23.173,33.2H5.337A4.09,4.09,0,0,1,1.25,29.118V5.337A4.09,4.09,0,0,1,5.337,1.25H23.173A4.09,4.09,0,0,1,27.26,5.337V17.376a1.115,1.115,0,1,1-2.229,0V5.337a1.861,1.861,0,0,0-1.858-1.858H5.337A1.861,1.861,0,0,0,3.479,5.337v23.78a1.861,1.861,0,0,0,1.858,1.858H23.173a1.409,1.409,0,0,0,.34-.031,1.136,1.136,0,0,1,1.376,1.086,1.109,1.109,0,0,1-.956,1.1,3.747,3.747,0,0,1-.761.07Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25115",
    "data-name": "Path 25115",
    d: "M16.769,8.479H6.365a1.115,1.115,0,0,1,0-2.229h10.4a1.115,1.115,0,0,1,0,2.229Z",
    transform: "translate(1.945 2.431)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25116",
    "data-name": "Path 25116",
    d: "M13.8,12.479H6.365a1.115,1.115,0,0,1,0-2.229H13.8a1.115,1.115,0,1,1,0,2.229Z",
    transform: "translate(1.945 4.376)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25117",
    "data-name": "Path 25117",
    d: "M17.36,20.461a1.106,1.106,0,0,1-.788-.327l-1.486-1.486a1.115,1.115,0,1,1,1.575-1.575l.7.7,2.185-2.183a1.115,1.115,0,1,1,1.575,1.575l-2.973,2.973a1.106,1.106,0,0,1-.788.327Z",
    transform: "translate(6.556 6.799)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkOrder);
export default __webpack_public_path__ + "static/media/WorkOrder.26ae49bfc58be3a4a77d02750a694541.svg";
export { ForwardRef as ReactComponent };